import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React, { forwardRef, useContext } from 'react';
import { defaultTheme, useComponentTheme } from '@chegg-ui/theme';
import { ThemeContext } from 'styled-components';
import { ButtonLabel } from '../shared';
import { getPrimaryThemeConfig, PrimaryButtonContainer } from '../styles';
var Button = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _themeContext$cuiThem;

  var children = _ref.children,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      isLoading = _ref.isLoading,
      loadingText = _ref.loadingText,
      dataTest = _ref['data-test'],
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'button' : _ref$type,
      theme = _ref.theme,
      leadingIcon = _ref.leadingIcon,
      trailingIcon = _ref.trailingIcon,
      buttonProps = _objectWithoutProperties(_ref, ["children", "size", "isLoading", "loadingText", "data-test", "type", "theme", "leadingIcon", "trailingIcon"]);

  var themeContext = useContext(ThemeContext);
  var componentTheme = useComponentTheme({
    name: 'PrimaryButton',
    theme: getPrimaryThemeConfig(theme)
  });

  if (((themeContext === null || themeContext === void 0 ? void 0 : (_themeContext$cuiThem = themeContext.cuiTheme) === null || _themeContext$cuiThem === void 0 ? void 0 : _themeContext$cuiThem.name) || defaultTheme.name) === 'horizon' && (size === 'xsmall' || size === 'small')) {
    console.error("primary button cannot be rendered at ".concat(size, " size."));
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }

  return /*#__PURE__*/React.createElement(PrimaryButtonContainer, _extends({}, buttonProps, {
    "data-test": dataTest ? dataTest : undefined,
    size: size,
    isLoading: isLoading,
    ref: ref,
    type: type,
    customTheme: componentTheme
  }), /*#__PURE__*/React.createElement(ButtonLabel, {
    isLoading: isLoading,
    size: size,
    loadingText: loadingText,
    customTheme: componentTheme,
    leadingIcon: leadingIcon,
    trailingIcon: trailingIcon
  }, children));
});
Button.displayName = 'Button';
export default Button;